import React from 'react'
import PropTypes from 'prop-types'
import Video from 'components/Video'
import { View } from 'components/View'

export function ExerciseVideo ({
  videoUrl,
  posterUrl,
  isMobileScreen,
  shouldAutoPlay
}) {
  if (!videoUrl || !posterUrl) {
    return null
  }

  return (
    <View
      m={isMobileScreen ? 'unset' : '0 auto'}
      w={isMobileScreen ? 'unset' : '500px'}
      mb='1.59em'
      px={isMobileScreen ? 1.5 : 0}
    >
      <Video
        shouldAutoPlay={shouldAutoPlay}
        source={videoUrl}
        poster={posterUrl}
        // To force video.js to re-render
        key={videoUrl}
      />
    </View>
  )
}

ExerciseVideo.propTypes = {
  videoUrl: PropTypes.string,
  posterUrl: PropTypes.string,
  isMobileScreen: PropTypes.bool.isRequired,
  shouldAutoPlay: PropTypes.bool
}
